import { User } from '@/api/rest/resources/types/user';

export const getUserBody = (user: User) => ({
  id: user.id,
  fullname: `${user.firstname} ${user.lastname}`,
  language: user.language,
  email: user.email,
  organization: user.membership.organization.name ?? '',
});
